import { isAiVoiceReceptionistAvailable } from '@/utils/webAiWidgetAvailability';
import webAiWidgetRouteGuard from './webAIWidgetRouteGuard';

const WEB_AI_WIDGET_ROUTE = { name: 'online-presence-web-ai-widget', replace: true };

// The voice channel settings page needs the web AI widget (same gate as the rest
// of the module) and, on top of that, the AI Voice Receptionist package. Without
// the package the page is sent back to the widget settings rather than the
// dashboard, since the widget itself is still available.
const voiceChannelSettingsRouteGuard = async (to, from, next) => {
  let widgetAllowed = false;
  let widgetRedirect;
  await webAiWidgetRouteGuard(to, from, (target) => {
    if (target === undefined) {
      widgetAllowed = true;
    } else {
      widgetRedirect = target;
    }
  });
  if (!widgetAllowed) {
    next(widgetRedirect);
    return;
  }

  try {
    if (await isAiVoiceReceptionistAvailable()) {
      next();
      return;
    }
  } catch {
    /* treated as unavailable */
  }
  next(WEB_AI_WIDGET_ROUTE);
};

export default voiceChannelSettingsRouteGuard;
